import axios from "axios"

export const isTransientRefreshFailure = (error: unknown): boolean =>
  axios.isAxiosError(error) &&
  (error.response === undefined ||
    error.response.status >= 500 ||
    error.response.status === 429)
